import fetchApiWithAuth from './fetch';

export type OrderLimitMeta = {
  id: number;
  mp_warehouse_id: number;
  name: string;
  is_active: boolean;
  is_default: boolean;
  order_limit: number;
  sort_order: number;
  articles: string[];
  article_count: number;
};

async function readError(result: Response, fallback: string): Promise<string> {
  const text = await result.text();
  try {
    const json = JSON.parse(text);
    if (typeof json?.message === 'string') return json.message;
    if (Array.isArray(json?.message)) return json.message.join(', ');
  } catch {
    /* plain text */
  }
  return text || fallback;
}

export async function list(mpWarehouseId: number): Promise<OrderLimitMeta[]> {
  const qs = `?mp_warehouse_id=${encodeURIComponent(String(mpWarehouseId))}`;
  const result = await fetchApiWithAuth(`/api/order_limit_metas${qs}`);
  if (!result.ok) throw new Error(await readError(result, 'Ошибка загрузки meta'));
  return result.json();
}

export async function create(body: {
  mp_warehouse_id: number;
  name: string;
  order_limit?: number | null;
  is_active?: boolean;
  articles?: string[];
}): Promise<OrderLimitMeta> {
  const result = await fetchApiWithAuth('/api/order_limit_metas', {
    method: 'POST',
    body: JSON.stringify(body),
  });
  if (!result.ok) throw new Error(await readError(result, 'Ошибка создания meta'));
  return result.json();
}

export async function update(
  id: number,
  body: {
    name?: string;
    order_limit?: number | null;
    is_active?: boolean;
    sort_order?: number;
  },
): Promise<OrderLimitMeta> {
  const result = await fetchApiWithAuth(`/api/order_limit_metas/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
  if (!result.ok) throw new Error(await readError(result, 'Ошибка обновления meta'));
  return result.json();
}

export async function remove(id: number): Promise<void> {
  const result = await fetchApiWithAuth(`/api/order_limit_metas/${id}`, {
    method: 'DELETE',
  });
  if (!result.ok) throw new Error(await readError(result, 'Ошибка удаления meta'));
}

export async function addArticles(
  id: number,
  articles: string[],
): Promise<OrderLimitMeta> {
  const result = await fetchApiWithAuth(`/api/order_limit_metas/${id}/articles`, {
    method: 'POST',
    body: JSON.stringify({ articles }),
  });
  if (!result.ok) {
    throw new Error(await readError(result, 'Ошибка добавления артикулов'));
  }
  return result.json();
}

export async function removeArticles(
  id: number,
  articles: string[],
): Promise<OrderLimitMeta> {
  const result = await fetchApiWithAuth(`/api/order_limit_metas/${id}/articles`, {
    method: 'DELETE',
    body: JSON.stringify({ articles }),
  });
  if (!result.ok) {
    throw new Error(await readError(result, 'Ошибка удаления артикулов'));
  }
  return result.json();
}
